import { Controller } from "stimulus"

// Opens/closes the "Your next steps" goal picker modal.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.hidden = false
    document.body.style.overflow = "hidden"
  }

  close() {
    this.dialogTarget.hidden = true
    document.body.style.overflow = ""
  }

  closeOnEsc(event) {
    if (event.key === "Escape" && !this.dialogTarget.hidden) this.close()
  }

  disconnect() {
    // A Turbo Stream replace can remove the open modal without close() running;
    // make sure the body scroll-lock never gets stranded.
    document.body.style.overflow = ""
  }
}
